import React from 'react';
import { MagazineArticlesContextProviderProps } from './interfaces';

const MagazineArticlesContext =
  React.createContext<MagazineArticlesContextProviderProps>({
    articles: [],
  });

export const MagazineArticlesContextProvider = ({
  children,
  ...value
}: MagazineArticlesContextProviderProps) => {
  return (
    <MagazineArticlesContext.Provider value={value}>
      {children}
    </MagazineArticlesContext.Provider>
  );
};

export default MagazineArticlesContext;
